import React, { useState, useEffect } from 'react';

const Intro = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Intro animation duration: 5.5 seconds (LED flicker 1.5s + HC expansion 2.5s + green transition 1s + fade 0.5s)
    const timer = setTimeout(() => {
      setIsVisible(false);
      onComplete();
    }, 5500);

    return () => clearTimeout(timer);
  }, [onComplete]);

  // The HC text + metallic shine have been removed; no JS nudge required.

  if (!isVisible) return null;

  return (
    <div className="intro-overlay">
      {/* DARKNESS LAYER - lifts when LEDs illuminate */}
      <div className="intro-darkness"></div>
      
      {/* TWINKLING STARS */}
      <div className="stars-container">
        {Array.from({ length: 50 }).map((_, i) => (
          <div key={i} className={`star star-${i % 5}`} style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 3}s`
          }}></div>
        ))}
      </div>

      {/* LEFT SIDE: Multiple smoke streams */}
      <div className="smoke-side smoke-left">
        <div className="smoke-stream stream-1"></div>
        <div className="smoke-stream stream-2"></div>
        <div className="smoke-stream stream-3"></div>
        <div className="smoke-wave wave-1"></div>
        <div className="smoke-wave wave-2"></div>
      </div>

      {/* RIGHT SIDE: Multiple smoke streams */}
      <div className="smoke-side smoke-right">
        <div className="smoke-stream stream-1"></div>
        <div className="smoke-stream stream-2"></div>
        <div className="smoke-stream stream-3"></div>
        <div className="smoke-wave wave-1"></div>
        <div className="smoke-wave wave-2"></div>
      </div>

      {/* AGGRESSIVE BLADE LED HEADLIGHTS with L-SHAPED DRL */}
      <div className="headlight-assembly headlight-left-assembly">
        <div className="blade-headlight blade-left">
          {/* Main blade LED - sharp angular shape */}
          <div className="blade-main"></div>
          {/* Secondary blade - thinner accent */}
          <div className="blade-accent"></div>
          <div className="blade-accent-alt"></div>
          {/* L-Shaped DRL Signature */}
          <div className="drl-l-shape">
            <div className="drl-horizontal"></div>
            <div className="drl-vertical"></div>
            <div className="drl-corner-glow"></div>
          </div>
        </div>
        <div className="headlight-glow headlight-glow-left"></div>
      </div>

      <div className="headlight-assembly headlight-right-assembly">
        <div className="blade-headlight blade-right">
          {/* Main blade LED - sharp angular shape */}
          <div className="blade-main"></div>
          {/* Secondary blade - thinner accent */}
          <div className="blade-accent"></div>
          <div className="blade-accent-alt"></div>
          {/* L-Shaped DRL Signature */}
          <div className="drl-l-shape">
            <div className="drl-horizontal"></div>
            <div className="drl-vertical"></div>
            <div className="drl-corner-glow"></div>
          </div>
        </div>
        <div className="headlight-glow headlight-glow-right"></div>
      </div>

      {/* CENTER: Collision dust cloud and centered elements */}
      <div className="intro-center-anchor">
        <div className="collision-center centered">
        <div className="dust-layer dust-1"></div>
        <div className="dust-layer dust-2"></div>
        <div className="dust-layer dust-3"></div>
        {/* <div className="dust-particles">
          {Array.from({ length: 12 }).map((_, i) => (
            <div key={i} className={`dust-particle p${i}`}></div>
          ))}
        </div> */}
        </div>
        {/* SHOCKWAVE */}
      

      {/* PREMIUM HC EXPANSION REVEAL */}
      <div className="name-container centered">
        {/* HC Metallic Initials that expand to full name in place */}
        <div className="hc-phase">
          <div className="hc-wrapper">
            <div className="hc-letter hc-h">
              <span className="hc-text">H</span>
              <span className="hc-expanded">arish</span>
              <div className="hc-shine shine-1"></div>
              <div className="hc-shine shine-2"></div>
              <div className="hc-corner corner-tl"></div>
              <div className="hc-corner corner-tr"></div>
              <div className="hc-corner corner-bl"></div>
              <div className="hc-corner corner-br"></div>
            </div>
            <div className="hc-letter hc-c">
              <span className="hc-text">C</span>
              <span className="hc-expanded">hittoor</span>
              <div className="hc-shine shine-1"></div>
              <div className="hc-shine shine-2"></div>
              <div className="hc-corner corner-tl"></div>
              <div className="hc-corner corner-tr"></div>
              <div className="hc-corner corner-bl"></div>
              <div className="hc-corner corner-br"></div>
            </div>
          </div>
          <div className="hc-glow"></div>
        </div>

        {/* Particle burst */}
        {/* <div className="particle-burst">
          {Array.from({ length: 12 }).map((_, i) => (
            <div key={i} className={`burst-particle bp${i}`}></div>
          ))}
        </div> */}
      </div>
      </div>
    </div>
  );
};

export default Intro;
